import { ButtonsContainer } from 'borispage/admintab/doctab/AdminNewDocumentPopupPage';
import { TransparentOverlay } from 'borispage/common/AdminCommonComponents';
import { withIsMobile } from 'hoc/withIsMobile';
import { withLoginInfo } from 'hoc/withLoginInfo';
import { i18ntrans, tc } from 'language/i18nkey';
import { IfLoginInfo } from 'models/IfLoginInfo';
import React, { useState, useEffect } from 'react';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import { ITemporaryListData } from 'repositories/SsqDataRepository';
import { Btn } from 'style/CommonStyledComponents';
import { fontFamilyBold, fontFamilyRegular } from 'style/fonts';
import styled from 'styled-components';
import { docutil } from 'util/docutil';
import { LoginUtil } from 'util/loginutil';
import { docwriteutil } from '../common/docwriteutil';
import { withZstdDocWrite, ZstdDocWrite } from '../common/useZstdDocWrite';
import { DropDownBtn } from './DropDownBtn';
import { TempDataPopupWrap } from './TempDataPopupWrap';

interface Props {
  orgDocId: number;
  onBtnCmd: (cmd, param?) => void;
  tempDataList: ITemporaryListData[];
  isMobile: boolean;
  loginInfo: IfLoginInfo;
}

function DocWriteBtns(props: Props & ZstdDocWrite) {
  const navigate = useNavigate();
  const location = useLocation();
  const params = useParams() as { orgDocId: string; docId: string };

  const [showTempDataListPopup, setShowTempDataListPopup] = useState(false);
  const [scrollY, setScrollY] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      if (window.scrollY > 0) {
        setScrollY(true);
      } else {
        setScrollY(false);
      }
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    return () => {
      window.removeEventListener('scroll', onScroll);
    };
  }, []);

  const trans = docwriteutil.getadmintrans;

  const getIsModify = () => {
    const page = props.pageType;
    if (page === 'NEW') {
      const docId = Number(params.orgDocId);
      if (docId > 0) return true;
    } else if (page === 'TEMP') {
      const docId = Number(params.docId);
      if (docId > 0) return true;
    }
    return false;
  };
  const isModify = getIsModify();

  const t = i18ntrans.admin;

  const loginutil = new LoginUtil(props.loginInfo);
  const docType = props.inputDoc?.docType;

  const history = {
    push: (path: string) => navigate(path),
    location: { pathname: location.pathname }
  };

  return (
    <ResponsiveButtonsContainer className={scrollY ? 'sticky' : ''}>
      <div className={'container'}>
        {['NEW', 'TEMP'].includes(props.pageType) && (
          <TitleWrap className={'title-wrap'}>
            <Title>{isModify ? t('I18N_DOCWRITE_MOD_TITLE') : t('I18N_DOCWRITE_NEW_TITLE')}</Title>
            <SubTitle>{isModify ? t('I18N_DOCWRITE_MOD_SUBTITLE') : t('I18N_DOCWRITE_NEW_SUBTITLE')}</SubTitle>
          </TitleWrap>
        )}
        <div className={'button-wrap'}>
          {props.pageType === 'TEMP' && (
            <Btn
              className={'delete-button width-auto batch-button'}
              onClick={async () => await props.onBtnCmd('delete-doc')}
            >
              {trans('I18N_BUTTON_TEMP_DELETE')}
            </Btn>
          )}
          {props.pageType !== 'TEMP' && props.orgDocId > 0 && (
            <Btn className={'delete-button batch-button'} onClick={async () => await props.onBtnCmd('delete-doc')}>
              {trans('I18N_BUTTON_DELETE')}
            </Btn>
          )}
          {loginutil.employLogined() && props.orgDocId > 0 && (
            <Btn className={'copy-button batch-button'} onClick={() => props.onBtnCmd('copy')}>
              {trans('I18N_DOCWRITE_BTN_COPY')}
            </Btn>
          )}
          <Btn className={'batch-button'} onClick={() => props.onBtnCmd('click-preview')}>
            {trans('I18N_BUTTON_PREVIEW')}
          </Btn>

          <div className={'tempo-button-wrap'}>
            <Btn className={'batch-button'} onClick={() => props.onBtnCmd('tmp-save')}>
              {trans('I18N_BUTTON_TEMP_SAVE')}
            </Btn>
            <Btn
              className={'tempo-count-button'}
              onClick={() => setShowTempDataListPopup(!showTempDataListPopup)}
            >
              {props.tempDataList?.length || 0}
            </Btn>
            {showTempDataListPopup && props.tempDataList.length !== 0 && (
              <TempDataPopupWrap temporaryDataList={props.tempDataList} trans={trans} history={history} />
            )}
            {showTempDataListPopup && props.tempDataList.length !== 0 && (
              <TransparentOverlay
                className={'Tempo_overlay'}
                onClick={() => {
                  setShowTempDataListPopup(!showTempDataListPopup);
                }}
              />
            )}
          </div>
          <Btn
            className={'post-button'}
            onClick={() => {
              if (isModify) {
                if (!confirm(trans('I18N_DOCWRITE_OVERWRITE_MSG'))) {
                  console.log('canceled..');
                  return;
                }
              }
              props.onBtnCmd('save');
            }}
          >
            {!isModify &&
              (docutil.approvalRequried(docType) ? trans('I18N_BUTTON_REQUEST') : trans('I18N_DOCWRITE_BTN_REGIST'))}
            {isModify &&
              (docutil.approvalRequried(docType)
                ? trans('I18N_BUTTON_REQUEST_MOD')
                : trans('I18N_DOCWRITE_BTN_REGIST_MOD'))}
          </Btn>
          <DropDownBtn
            kvs={[
              { key: 'cmd-new', val: tc('i18n_dd_doc_new') },
              { key: 'cmd-copy', val: tc('i18n_dd_doc_copy') },
              ...(props.orgDocId > 0 ? [{ key: 'cmd-del', val: tc('i18n_dd_doc_delete') }] : []),
            ]}
            sels={[]}
            onChange={(ele) => {
              if (ele.key === 'cmd-del') {
                props.onBtnCmd('delete-doc');
              }
            }}
          />
        </div>
      </div>
    </ResponsiveButtonsContainer>
  );
}

export default withLoginInfo(withIsMobile(withZstdDocWrite(DocWriteBtns)));

export const TitleWrap = styled.div`
  display: flex;
  align-items: end;
`;

export const Title = styled.div`
  font-family: ${fontFamilyBold};
  font-size: 2rem;
  font-weight: 700;
  color: #2a2c2f;
  padding-right: 0.7rem;
`;
export const SubTitle = styled.div`
  font-family: ${fontFamilyRegular};
  font-size: 1rem;
  font-weight: 400;
  color: #7783a1;
  padding-bottom: 3px;
`;

const ResponsiveButtonsContainer = styled(ButtonsContainer)`
  > .container {
    flex-wrap: wrap;
    gap: 1rem;
    align-items: center;
  }
`;
